export default __webpack_public_path__ + "static/chalk-2cd6d40a625213627b73104c75cd938a.webm";